/**
 * Commits a directory search query to personal recents after typing settles.
 */

import { useEffect } from 'react';
import { DIRECTORY_RECENT_PERSIST_DEBOUNCE_MS } from '../services/directoryRecentSearches';

function normalizeDirectoryQuery(raw: string): string {
  return raw.trim().replace(/\s+/g, ' ');
}

/**
 * After {@link DIRECTORY_RECENT_PERSIST_DEBOUNCE_MS} without changes, persist
 * the normalized query (min length 2). Cancels in-flight timers on change/unmount.
 */
export function useDebouncedDirectoryRecentPersist(
  inputValue: string,
  addRecent: (query: string) => void,
  debounceMs: number = DIRECTORY_RECENT_PERSIST_DEBOUNCE_MS,
): void {
  useEffect(() => {
    const normalized = normalizeDirectoryQuery(inputValue);
    if (normalized.length < 2) return;
    const timer = window.setTimeout(() => {
      addRecent(normalized);
    }, debounceMs);
    return () => window.clearTimeout(timer);
  }, [inputValue, addRecent, debounceMs]);
}
